"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var NgbModalBackdrop = (function () {
    function NgbModalBackdrop() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NgbModalBackdrop.prototype, "backdropClass", void 0);
    NgbModalBackdrop = __decorate([
        core_1.Component({
            selector: 'ngb-modal-backdrop',
            template: '',
            host: { '[class]': '"modal-backdrop fade show" + (backdropClass ? " " + backdropClass : "")' }
        })
    ], NgbModalBackdrop);
    return NgbModalBackdrop;
}());
exports.NgbModalBackdrop = NgbModalBackdrop;
//# sourceMappingURL=modal-backdrop.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/modal/modal-backdrop.js
// module id = 52
// module chunks = 0